import { Component, inject, computed, signal, effect } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';

import { AuthStore } from './core/store/authentication/authentication.store';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { LoadingOverlayComponent } from './shared/components/loading-overlay/loading-overlay.component';
import { filter } from 'rxjs';
import { BottomNavComponent } from './core/layout/components/footer/bottom-nav/bottom-nav.component';


@Component({
    standalone: true,
    selector: 'app-root',
    imports: [
      RouterOutlet,
      NavbarComponent,
      LoadingOverlayComponent,
      BottomNavComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Family Health Advantage - Portal';
  authStore = inject(AuthStore)
  private router = inject(Router);

  isRouteLoading = signal(false);
  authStatus = computed(() => this.authStore.authStatus())
  constructor() {
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isRouteLoading.set(true);
        } else {
          this.isRouteLoading.set(false);
        }
      });

    effect(() => {
      if(this.authStatus() === 'error') {
        this.router.navigate(['/login']);
      }
    })
  }
  // Use computed to make it reactive, or just use the signal directly
  readonly $loggedIn = computed(() => this.authStore.isAuthenticated())
}
